export default "__VITE_ASSET__BPDPO9Cp__"